export default {
    routes: [
		// 收支明细相关路由
		{
			path: '/szmx',
			name: 'szmx',
			component: () => import('../../view/szmx/index.vue'),
			meta: {
				title: '收支明细',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/szmx/sr',
			name: 'szmx-sr',
			component: () => import('../../view/szmx/sr.vue'),
			meta: {
				title: '物业资金总收入',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/szmx/zc',
			name: 'szmx-zc',
			component: () => import('../../view/szmx/zc.vue'),
			meta: {
				title: '物业资金总支出',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/szmx/jfqk',
			name: 'szmx-jfqk',
			component: () => import('../../view/szmx/jfqk.vue'),
			meta: {
				title: '缴费明细',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/xqgk_menu',
			name: 'xqgk_menu',
			component: () => import('../../view/wyfw/xqgk_menu.vue'),
			meta: {
				title: '小区概况',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/ysgs',
			name: 'ysgs',
			component: () => import('../../view/ysgs.vue'),
			meta: {
				title: '预算公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyqy',
			name: 'wyqy',
			component: () => import('../../view/wyqy/index.vue'),
			meta: {
				title: '物业企业',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyjf',
			name: 'wyjf',
			component: () => import('../../view/wyqy/wyjf.vue'),
			meta: {
				title: '业主缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/szgs',
			name: 'szgs',
			component: () => import('../../view/wyqy/szgs.vue'),
			meta: {
				title: '收支公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw',
			name: 'wyfw',
			component: () => import('../../view/wyfw/index.vue'),
			meta: {
				title: '物业服务',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/crgl',
			name: 'crgl',
			component: () => import('../../view/wyfw/crgl.vue'),
			meta: {
				title: '出入管理',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/jflist',
			name: 'jflist',
			component: () => import('../../view/wyfw/jflist.vue'),
			meta: {
				title: '业主缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyflist',
			name: 'wyflist',
			component: () => import('../../view/wyfw/wyflist.vue'),
			meta: {
				title: '物业费列表',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/feepaiddetail',
			name: 'feepaiddetail',
			component: () => import('../../view/wyfw/feepaiddetail.vue'),
			meta: {
				title: '物业费列表',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/invoicefill',
			name: 'invoicefill',
			component: () => import('../../view/wyfw/invoicefill.vue'),
			meta: {
				title: '填写信息',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/invoicedetail',
			name: 'invoicedetail',
			component: () => import('../../view/wyfw/invoicedetail.vue'),
			meta: {
				title: '发票详情',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/jfdetail',
			name: 'jfdetail',
			component: () => import('../../view/wyfw/jfdetail.vue'),
			meta: {
				title: '业主缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/ggsydetail',
			name: 'ggsydetail',
			component: () => import('../../view/wyfw/ggsydetail.vue'),
			meta: {
				title: '物业公共收益',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/shjf',
			name: 'shjf',
			component: () => import('../../view/wyfw/wyjflist.vue'),
			meta: {
				title: '业主缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjf',
			name: 'wyjf',
			component: () => import('../../view/wyfw/wyjf.vue'),
			meta: {
				title: '业主缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/sjyz',
			name: 'sjyz',
			component: () => import('../../view/wyfw/shoujiyanzheng.vue'),
			meta: {
				title: '手机验证',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/cheweijf',
			name: 'cheweijf',
			component: () => import('../../view/wyfw/cheweijf.vue'),
			meta: {
				title: '车位缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/jfjl',
			name: 'jfjl',
			component: () => import('../../view/wyfw/jfjl.vue'),
			meta: {
				title: '缴费记录',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/ygpj',
			name: 'ygpj',
			component: () => import('../../view/wyfw/ygpj.vue'),
			meta: {
				title: '员工评价',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/ygpj/xq',
			name: 'ygpjxq',
			component: () => import('../../view/wyfw/ygpjxq.vue'),
			meta: {
				title: '员工评价',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj',
			name: 'wyjj',
			component: () => import('../../view/wyfw/wyjj/wyjj.vue'),
			meta: {
				title: '小区概况',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},{
			path: '/wyfw/wyjj/fyzc',
			name: 'fyzc',
			component: () => import('../../view/wyfw/wyjj/fyzc.vue'),
			meta: {
				title: '费用支出',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/ldz',
			name: 'ldz',
			component: () => import('../../view/wyfw/wyjj/ldz.vue'),
			meta: {
				title: '楼栋长',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/jbxxxq',
			name: 'jbxxxq',
			component: () => import('../../view/wyfw/wyjj/jbxxxq.vue'),
			meta: {
				title: '小区信息',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/sfbz',
			name: 'sfbz',
			component: () => import('../../view/wyfw/wyjj/sfbz.vue'),
			meta: {
				title: '收费标准',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},{
			path: '/wyfw/wyjj/wyfmx',
			name: 'wyfmx',
			component: () => import('../../view/wyfw/wyjj/wyfmx.vue'),
			meta: {
				title: '物业费明细',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},{
			path: '/flfg/xq',
			name: 'flfgxq',
			component: () => import('../../view/wyfw/wyjj/fgxq.vue'),
			meta: {
				title: '法律法规详情',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/sfxx',
			name: 'sfxx',
			component: () => import('../../view/wyfw/wyjj/sfxx.vue'),
			meta: {
				title: '收费信息',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/zsr',
			name: 'zsr',
			component: () => import('../../view/wyfw/wyjj/zsr.vue'),
			meta: {
				title: '总收入',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/srgs',
			name: 'srgs',
			component: () => import('../../view/wyfw/wyjj/srgs.vue'),
			meta: {
				title: '收入公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyqy/szgs/index',
			name: 'srgs-index',
			component: () => import('../../view/wyqy/szgs/index.vue'),
			meta: {
				title: '收支公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyqy/szgs/wyfgs',
			name: 'wyfgs',
			component: () => import('../../view/wyqy/szgs/wyfgs.vue'),
			meta: {
				title: '物业费收支公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyqy/szgs/ggsygs',
			name: 'ggsygs',
			component: () => import('../../view/wyqy/szgs/ggsygs.vue'),
			meta: {
				title: '公共收益收支公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyqy/szgs/dsdjgs',
			name: 'dsdjgs',
			component: () => import('../../view/wyqy/szgs/dsdjgs.vue'),
			meta: {
				title: '代收代交收支公示',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/fwht',
			name: 'fwht',
			component: () => import('../../view/wyfw/wyjj/fwht.vue'),
			meta: {
				title: '服务合同',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/fwry',
			name: 'fwry',
			component: () => import('../../view/wyfw/wyjj/fwry.vue'),
			meta: {
				title: '服务人员',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/fwsx',
			name: 'fwsx',
			component: () => import('../../view/wyfw/wyjj/fwsx.vue'),
			meta: {
				title: '服务事项',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/qyxx',
			name: 'qyxx',
			component: () => import('../../view/wyfw/wyjj/qyxx.vue'),
			meta: {
				title: '企业信息',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/kaoqin',
			name: 'fwsx',
			component: () => import('../../view/kaoqin/index.vue'),
			meta: {
				title: '考勤打卡',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wydjf',
			name: 'wydjf',
			component: () => import('../../view/wydjf/djflist.vue'),
			meta: {
				title: '物业代缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/ggsy',
			name: 'ggsy',
			component: () => import('../../view/wydjf/ggsylist.vue'),
			meta: {
				title: '公共收益代缴费',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/wyfw/wyjj/gtfy',
			name: 'gtfy',
			component: () => import('../../view/wyfw/wyjj/gtfy.vue'),
			meta: {
				title: '公摊费用',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			path: '/flfg',
			name: 'flfg',
			component: () => import('../../view/wyfw/wyjj/flfg.vue'),
			meta: {
				title: '法律法规',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
	]
}
